var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "13.7 12.88 6.25 12.88 6.25 2.62 1.8 2.62 1.8 7.17 0.3 7.17 0.3 1.12 7.75 1.12 7.75 11.38 12.2 11.38 12.2 6.83 13.7 6.83 13.7 12.88"
})));
export default SvgSquare;